import { appConfig } from "src/config";
import getStore, { CoreReduxState } from "src/utils/redux/store";

export const MEMBERSHIP_PRODUCT_NAMES: readonly string[] = [
  "telehealth-medtier-membership",
];

export function isMembershipProductName(
  productName?: string
): productName is (typeof MEMBERSHIP_PRODUCT_NAMES)[number] {
  return productName != null && MEMBERSHIP_PRODUCT_NAMES.includes(productName);
}

// Also exposed as a pageset segment via src/utils/userSegment/index.ts.
export function isMembershipCancelFlowEnabled() {
  // Worker-controlled GrowConfig kill switch with no URL override, so the flow
  // can't be reached in production before it is turned on.
  return appConfig.MEMBERSHIP_CANCEL_FLOW_ENABLED;
}

// Also exposed as a pageset segment via src/utils/userSegment/index.ts.
export function isSubscriptionMembership(
  state: CoreReduxState = getStore().getState()
) {
  return (
    isMembershipCancelFlowEnabled() &&
    MEMBERSHIP_PRODUCT_NAMES.includes(state.serverContext.product_name)
  );
}
